import { NgModule } from '@angular/core';

import { ProductionRoutingModule } from './production-routing.module';
import { SharedModule } from '@digiwall/goliath-core';

@NgModule({
  declarations: [],
  imports: [SharedModule, ProductionRoutingModule],
})
export class ProductionModule {}
